import React, { useState, useEffect } from "react";
import { Button } from "primereact/button";
import { useFormik } from "formik";
import { AutoComplete } from "primereact/autocomplete";
import { classNames } from "primereact/utils";
import { Checkbox } from "primereact/checkbox";
import { Calendar } from "primereact/calendar";
import { InputText } from "primereact/inputtext";
import { Dialog } from "primereact/dialog";
import { allocationService } from "../../services";
import moment from "moment";
import { toast } from "react-toastify";
import properties from "../../config/environmentProperties";
import { InputTextarea } from "primereact/inputtextarea";
import { Dropdown } from "primereact/dropdown";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { Accordion, AccordionTab } from 'primereact/accordion';

export const ManagerAllocation = ({ setShow, ac, clickedTeamUser, dashboardReload, setMgrDialog, responseData }) => {
  const [resourceAvailable, setResourceAvailable] = useState("");
  const [filteredUsers, setFilteredUsers] = useState([]);
  const [allocationTypes, setAllocationTypes] = useState([]);
  const [selectedUsers, setSelectedUsers] = useState([]);
  const [isReject, setIsReject] = useState(false);
  const [showRejDialog, setShowRejDialog] = useState(false);
  const [checkBillable, setCheckBillable] = useState(false);
  const [resAllocatedData, setResAllocatedData] = useState([]);
  const [filteredUserProjects, setFilteredUserProjects] = useState([]);
  const [fullAllocationDisabled, setFullAllocationDisabled] = useState(false);
  const [partialAllocationDisabled, setPartialAllocationDisabled] = useState(false);
  const [otAllocationDisabled, setOtAllocationDisabled] = useState(false);
  const [allocatedPro, setAllocatedPro] = useState([]);
  const [resourceRoleId, setResourceRoleId] = useState();
  const [resourceRole, setResourceRole] = useState([]);
  const [billingRate, setBillingRate] = useState([]);


  const [selectedRowData, setSelectedRowData] = useState({});

  const imgPath = properties.currentEnvironment.docPath + "images/";
  let teamStartDateObject;
  let teamEndDateObject;
  var teamDataUser;

  useEffect(() => {
    getProjectsByUser();
    getAllocationType();
    if (clickedTeamUser) {
      setResourceAvailable(clickedTeamUser.availability);
      if (clickedTeamUser.availability === 100) {
        formik.setFieldValue("alloc100", true);
        formik.setFieldValue("allocPartial", false);
        formik.setFieldValue("ot", false);
        setFullAllocationDisabled(false);
        setPartialAllocationDisabled(false);
        setOtAllocationDisabled(true);
      } else if (clickedTeamUser.availability === 0) {
        formik.setFieldValue("ot", true);
        formik.setFieldValue("allocPartial", false);
        formik.setFieldValue("alloc100", false);
        setFullAllocationDisabled(true);
        setPartialAllocationDisabled(true);
        setOtAllocationDisabled(false);
      } else {
        formik.setFieldValue("allocOther", clickedTeamUser.availability);
        formik.setFieldValue("allocPartial", true);
        formik.setFieldValue("ot", false);
        formik.setFieldValue("alloc100", false);
        setFullAllocationDisabled(true);
        setPartialAllocationDisabled(false);
        setOtAllocationDisabled(true);
      }
      let allocatedProject = [];
      allocatedProject = clickedTeamUser.Allocations.filter((el) => {
        return el.status !== 4;
      });
      setAllocatedPro(allocatedProject);
    }
  }, []);

  const getProjectsByUser = () => {
    allocationService.getAllProjectByUser().then((resp) => {
      setFilteredUserProjects(resp?.data?.data);
    });
  };

  const getAllocationType = () => {
    allocationService.getAllocationtypes().then((resp) => {
      setAllocationTypes(resp?.data?.data);
    });
  };

  // const getResourceRole = (proId) => {
  //   allocationService.getAllResourceRole(proId).then((resp) => {
  //     setResourceRole(resp?.data?.data);
  //   });
  // };

  const getBillingRate = (roleId) => {
    allocationService.getAllBillingRate(roleId).then((resp) => {
      const modifiedData = resp?.data?.data.map(item => ({
        id: item.id,
        rate: `${item.rate} ${item.currency}/${item.billingType.title}`,
      }));
      setBillingRate(modifiedData);
    });
  };

  if (clickedTeamUser) {
    teamDataUser = [
      {
        name: clickedTeamUser.firstName.toUpperCase() + " " + clickedTeamUser.lastName.toUpperCase(),
        id: clickedTeamUser.id,
        isBillable: checkBillable,
        designation: clickedTeamUser?.Designation?.title,
      },
    ];
    teamStartDateObject = "";
    teamEndDateObject = "";
  }

  const formik = useFormik({
    initialValues: {
      project: "",
      resourceRole: "",
      billingRate: "",
      allocation: 0,
      alloc100: false,
      allocOther: "",
      allocPartial: false,
      ot: false,
      startDate: clickedTeamUser ? teamStartDateObject : "",
      endDate: clickedTeamUser ? teamEndDateObject : "",
      user: "",
      reason: "",
    },
    validate: (data) => {
      let errors = {};
      if (!data.project) {
        errors.project = "Project is required*";
      }
      // if (!data.resourceRole) {
      //   errors.resourceRole = "Role is required*";
      // }
      // if (!data.billingRate) {
      //   errors.billingRate = "Rate is required*";
      // }
      if (Object.keys(selectedRowData).length === 0) {
        errors.resourceRole = "please select role for this project*";
      }
      if (!data.startDate) {
        errors.startDate = "Start Date is required*";
      }
      if (!data.endDate) {
        errors.endDate = "End Date is required*";
      }
      if (clickedTeamUser) {
        if (teamDataUser.length === 0) {
          errors.user = "Please select minimum one user*";
        }
      } else {
        if (selectedUsers.length === 0) {
          errors.user = "Please select minimum one user*";
        }
      }
      if (data.endDate && data.startDate) {
        if (moment(data.startDate) > moment(data.endDate)) {
          errors.endDate = "End Date is must be above than start date";
        }
      }
      if (data.allocOther > resourceAvailable) {
        errors.allocOther = "Allocation should not be greater than availablity (" + resourceAvailable + "%)";
      }
      return errors;
    },

    onSubmit: (data) => {
      if (isReject) {
        rejectManagerAllocation(data);
      } else {
        createManagerAllocation(data);
        responseData(resAllocatedData);
      }
      formik.resetForm();
    },
  });

  const handleDateChange = (date) => {
    formik.setFieldValue("startDate", date);
    formik.setFieldValue("endDate", "");
  };

  const clearReason = () => {
    formik.setFieldValue("reason", "");
  };

  const createManagerAllocation = async (data) => {
    setShow(false);
    const dataobj = {
      projectId: fetchProjectId(data.project),
      // projectRoleId: data.resourceRole.id,
      // billingRateId: data.billingRate.id,
      projectRoleId: selectedRowData?.id,
      billingRateId: selectedRowData?.billingRate[0]?.id,
      startDate: moment(data.startDate).format("YYYY-MM-DD"),
      endDate: moment(data.endDate).format("YYYY-MM-DD"),
      allocationType: fetchAllocation(data),
      percentage: fetchPercentage(data),
      users: clickedTeamUser ? teamDataUser : selectedUsers.flat(1),
    };
    if (
      formik.values.alloc100 ||
      formik.values.allocOther > 0 ||
      formik.values.ot
    ) {
      try {
        allocationService.createManagerAllocation(dataobj).then(
          (resp) => {
            if (resp.status) {
              setResAllocatedData(responseData(resp.data.data));
              setMgrDialog(true);
            }
          },
          (err) => {
            toast.error(err.response.data.error);
          }
        );
      } catch (error) {
        toast.error("Unable to create allocation...");
      }
    } else {
      toast.error("Allocation percentage not selected properly");
    }
  };

  const rejectManagerAllocation = async (data) => {
    setShow(false);
    try {
      allocationService.updateAllocationReject(data).then(
        (resp) => {
          dashboardReload();
          toast.success("Allocation rejected");
        },
        (err) => {
          toast.error(err.response.data.error);
        }
      );
    } catch (error) {
      toast.error("Unable to reject allocation");
    }
  };

  const isFormFieldValid = (name) =>
    !!(formik.touched[name] && formik.errors[name]);
  const getFormErrorMessage = (name) => {
    return (
      isFormFieldValid(name) && (
        <small className="p-error">{formik.errors[name]}</small>
      )
    );
  };

  const fetchAllocation = (data) => {
    var code = "100";
    if (data) {
      if (data.alloc100) {
        code = "100";
      } else if (data.allocPartial) {
        code = "PT";
      } else if (data.ot) {
        code = "OT";
      } else {
        code = "";
      }
    }

    var result = allocationTypes.filter((obj) => {
      return obj.code === code;
    });
    return result[0]?.id;
  };

  const fetchPercentage = (data) => {
    var result = 0;
    if (data) {
      if (data.alloc100) {
        result = 100;
      } else if (data.allocPartial) {
        result = data.allocOther;
      } else {
        result = 0;
      }
    }
    return result;
  };

  const searchUser = (event) => {
    if (event.query.trim().length > 2) {
      const dataobj = {
        queryString: event.query.trim()
      };
      allocationService.getBUAllocatedUsers(dataobj).then((resp) => {
        const dataObj = resp.data.data.map((v, i) => ({
          ...v,
          name: resp.data.data[i].name + "(" + resp.data.data[i].ecn + ")",
        }));
        setFilteredUsers(dataObj);
      });
    }
  };

  const allocHandler = (e) => {
    formik.handleChange(e);
    if (!formik.values.allocPartial) {
      formik.values.allocOther = "";
    }
    switch (e.target.name) {
      case "allocPartial":
        formik.setFieldValue("alloc100", false);
        formik.setFieldValue("ot", false);
        break;
      case "alloc100":
        formik.setFieldValue("allocPartial", false);
        formik.setFieldValue("ot", false);
        break;
      case "ot":
        formik.setFieldValue("alloc100", false);
        formik.setFieldValue("allocPartial", false);
        break;
      default:
    }
  };

  const selectedUser = (e) => {
    let resourceAvailablity = e?.value?.availability;
    setResourceAvailable(resourceAvailablity);
    if (resourceAvailablity === 100) {
      formik.setFieldValue("alloc100", true);
      formik.setFieldValue("allocPartial", false);
      formik.setFieldValue("ot", false);
      setFullAllocationDisabled(false);
      setPartialAllocationDisabled(false);
      setOtAllocationDisabled(true);
    } else if (resourceAvailablity === 0) {
      formik.setFieldValue("ot", true);
      formik.setFieldValue("allocPartial", false);
      formik.setFieldValue("alloc100", false);
      setFullAllocationDisabled(true);
      setPartialAllocationDisabled(true);
      setOtAllocationDisabled(false);
    } else {
      formik.setFieldValue("allocOther", resourceAvailablity);
      formik.setFieldValue("allocPartial", true);
      formik.setFieldValue("ot", false);
      formik.setFieldValue("alloc100", false);
      setFullAllocationDisabled(true);
      setPartialAllocationDisabled(false);
      setOtAllocationDisabled(true);
    }
    let isDuplicate = false;
    let firstName = e.value.name.split(" ")[0];
    let lastName = e.value.name.split(" ")[1];
    let dataobj = [
      {
        name: firstName.charAt(0).toUpperCase() + firstName.slice(1) + " " + lastName.charAt(0).toUpperCase() + lastName.slice(1),
        id: e?.value?.id,
        isBillable: false,
        designation: e?.value?.designation,
        availability: e?.value?.availability,
        photo: e?.value?.photo,
        allocations: e?.value?.allocations,
      },
    ];
    if (selectedUsers && dataobj.length > 0) {
      isDuplicate = selectedUsers.some((user) => user[0].id === dataobj[0].id);
    }

    let userInfo = localStorage.getItem("user");
    if (userInfo) {
      userInfo = JSON.parse(userInfo);
      if (userInfo?.id === dataobj[0].id) {
        toast.info("You cannot select yourself.");
        return;
      }
    }
    if (isDuplicate) {
      toast.info("You have already selected this user.");
    } else {
      // setSelectedUsers([...selectedUsers, dataobj]);
      setSelectedUsers([dataobj]);
    }
    formik.setFieldValue("user", "");
  };

  const handleBillable = (e) => {
    if (clickedTeamUser) {
      checkBillable ? setCheckBillable(false) : setCheckBillable(true);
    } else {
      var selectedid = e.target.id;
      let updatedList = selectedUsers.map((item) => {
        if (item[0].id === selectedid) {
          item[0].isBillable = !item[0].isBillable;
          return item;
        }
        return item;
      });
      setSelectedUsers(updatedList);
    }
  };

  const deleteSelectedUser = (data) => {
    setSelectedUsers([]);
    // var foundIndex = selectedUsers.findIndex((u) => u.id === data.id);
    // selectedUsers.splice(foundIndex, 1);
  };

  const projectBodyTemplate = (rowData) => {
    return rowData.Project.title;
  };

  const fetchProjectStartEndDate = (name) => {
    let obj;
    filteredUserProjects.map((item) => {
      if (item.title === name) {
        obj = item
      }
    });
    return obj;
  }

  const fetchProjectId = (name) => {
    var found;
    filteredUserProjects.map((item) => {
      if (item.title === name) {
        found = item.id;
      }
    });
    return found;
  };

  const changeProject = (e) => {
    let selectedProjectId = fetchProjectId(e.value);
    let projectDateObj = fetchProjectStartEndDate(e.value);
    
    // getResourceRole(selectedProjectId);
    formik.handleChange(e);

    allocationService.getAllResourceRole(selectedProjectId).then((resp) => {
      setResourceRole(resp?.data?.data);
      formik.setFieldValue("startDate", new Date(projectDateObj.startDate));
      formik.setFieldValue("endDate", new Date(projectDateObj.endDate));
    });
  }

  const rateBody = (rowData) => {
    return (<>{rowData?.billingRate[0]?.currency + " " + rowData?.billingRate[0]?.rate + " " + rowData?.billingRate[0]?.billingType?.title}</>);
  }

  const onRowClick = (event) => {
    setSelectedRowData(event.data);
  };

  const rowClass = (rowData) => {
    return {
      'job-expended-row': rowData?.id === selectedRowData?.id
    }
    // if (Object.keys(editData).length === 0) {
    //   return {
    //     'job-expended-row': rowData?.id === selectedRowData?.id
    //   }
    // } else {
    //   return {
    //     'job-expended-row': rowData?.id === editData?.userProjectRoleId
    //   }
    // }
  }

  const changeResourceRole = (e) => {
    setResourceRoleId(e.value);
    formik.setFieldValue('resourceRole', e.value);
    getBillingRate(e.value.id);
  }


  // const changeBillingRate = (e) => {
  //   setBillingCurrency(e.value.currency);
  //   setBillingType(e.value.billingType.title);
  //   formik.setFieldValue('billingRate', e.value);
  // }

  return (
    <div className="Allocation">
      {ac && <h1>Pending Allocation</h1>}
      <form onSubmit={formik.handleSubmit}>
        <div className="p-fluid">
          <div className="field">
            <label htmlFor="name" className={classNames({ "p-error": isFormFieldValid("name") })}>
              Project*
            </label>
            <span className="p-float-label">
              <Dropdown filter id="project" name="project" placeholder="Select Project" optionLabel="title" optionValue="title" options={filteredUserProjects} onChange={(e) => changeProject(e)} value={formik.values.project} appendTo="self" className="project_search"/>
            </span>
            {getFormErrorMessage("project")}
          </div>

          {/* <div className="grid date-selection">
            <div className="col">
              <div className="field">
                <label htmlFor="name" className={classNames({ "p-error": isFormFieldValid("name") })}>
                  Resource Role*
                </label>
                <span className="p-float-label">
                  <Dropdown filter id="resourceRole" name="resourceRole" placeholder="Select Role" optionLabel="title" options={resourceRole} onChange={(e) => changeResourceRole(e)} value={formik.values.resourceRole} appendTo="self" />
                </span>
                {getFormErrorMessage("resourceRole")}
              </div>
            </div>
            <div className="col">
              <div className="field">
                  <label htmlFor="name" className={classNames({ "p-error": isFormFieldValid("name") })}>
                    Billing Rate*
                  </label>
                  <span className="p-float-label">
                    <Dropdown filter id="billingRate" name="billingRate" placeholder="Select Rate" optionLabel="rate" options={billingRate} onChange={formik.handleChange} value={formik.values.billingRate} appendTo="self" />
                  </span>
                  {getFormErrorMessage("billingRate")}
              </div>
            </div>
          </div> */}

          <div className="grid date-selection">
            <Accordion activeIndex={0} className="new-allocation" >
              <AccordionTab header="Resource Role & Rate">
                <DataTable dataKey="id" value={resourceRole} tableStyle={{ minWidth: '50rem' }} selectionMode="single" onRowClick={onRowClick} rowClassName={rowClass}>
                  <Column field="title" header="Role" headerStyle={{ width: "15rem" }}></Column>
                  <Column field="startDate" header="Start Date" headerStyle={{ width: "10rem" }}></Column>
                  <Column field="endDate" header="End Date" headerStyle={{ width: "10rem" }}></Column>
                  <Column field="count" header="No Of Position" headerStyle={{ width: "10rem" }}></Column>
                  <Column field="title" header="Rate" headerStyle={{ width: "12rem" }} body={rateBody}></Column>
                </DataTable>
              </AccordionTab>
            </Accordion>
            {getFormErrorMessage("resourceRole")}
          </div>

          <div className="grid date-selection mt-4">
            <div className="col-12">
              <div className="field mb-0">
                <label htmlFor="date">Start Date*</label>
                <span className="p-float-label">
                  <Calendar type="date" id="date" name="startDate" value={formik.values.startDate} onChange={(e) => handleDateChange(e.target.value)} dateFormat="dd/mm/yy" mask="99/99/9999" showIcon placeholder="Start Date" />
                  {getFormErrorMessage("startDate")}
                </span>
              </div>
            </div>
            <div className="col-12">
              <div className="field">
                <label htmlFor="date">End Date*</label>
                <span className="p-float-label">
                  <Calendar type="date" id="date" name="endDate" value={formik.values.endDate} onChange={formik.handleChange} dateFormat="dd/mm/yy" mask="99/99/9999" showIcon placeholder="End Date" minDate={new Date(formik.values.startDate)} disabled={!formik.values.startDate} />
                  {getFormErrorMessage("endDate")}
                </span>
              </div>
            </div>
          </div>
        </div>

        {clickedTeamUser && (
          <div className="user-container">
            {teamDataUser.map((item, i) => {
              return (
                <div>
                  <div className="grid">
                    <div className="col-4 p-0">
                      <div className="flex align-items-center gap-2">
                        {clickedTeamUser?.photo === "" ||
                          clickedTeamUser?.photo === null ? (
                          <span className="photo-span" style={{ height: "35px", width: "35px", borderRadius: "50%", border: "2px solid #d7e9ff", display: "flex", alignItems: 'center', justifyContent: 'center', fontSize: "18px", fontWeight: "600", color: "#1369b6", padding: '5px', paddingTop: '1px' }}>
                            {clickedTeamUser.firstName.toUpperCase().substr(0, 1)}
                            {clickedTeamUser.lastName.toUpperCase().substr(0, 1)}
                          </span>
                        ) : (
                          <img style={{ height: "50px", width: "50px", borderRadius: "50%", border: "3px solid #d7e9ff", Top: "16px", bottom: "16px", left: "16px" }} src={imgPath + clickedTeamUser?.photo || ""} alt="" />
                        )}
                      </div>
                    </div>
                    <div className="col-8 p-0">
                      <span className="userName"> <b> {item.name}</b>{" "} </span>
                      <br />
                      <span className="userName"> <div> {item.designation} </div> </span>
                      <span className="userName">Availability :<b> {clickedTeamUser.availability} %</b> </span>
                    </div>
                    <div className="col-12">
                      <div className="grid">
                        <div className="col-3 mt-2">
                          <Checkbox id={item.id} name={item.name} checked={item.isBillable} onChange={handleBillable} />
                        </div>
                        <div className="col-3 mt-2">Billable</div>
                      </div>
                    </div>
                  </div>
                  <Accordion activeIndex={null}>
                    <AccordionTab header="Resource Allocation">
                      <DataTable value={allocatedPro} responsiveLayout="scroll">
                        <Column field="id" header="ID" style={{ minWidth: "5rem" }}></Column>
                        <Column field="project" body={projectBodyTemplate} header="Project" style={{ minWidth: "15rem" }}></Column>
                        <Column field="percentage" header="Allocation(%)" style={{ minWidth: "8rem" }}></Column>
                      </DataTable>
                    </AccordionTab>
                  </Accordion>
                </div>
              );
            })}
          </div>
        )}

        {!clickedTeamUser && (
          <div>
            <div className="field">
              <div className="p-fluid">
                <label htmlFor="name" className={classNames({ "p-error": isFormFieldValid("name") })}>
                  Users*
                </label>
                <span className="p-float-label mt-2">
                  <AutoComplete value={formik.values.user} virtualScrollerOptions={{ itemSize: 38 }} name="user" placeholder="Search user" suggestions={filteredUsers} completeMethod={searchUser} field="name" aria-label="users" dropdownAriaLabel="Select user" onSelect={(e) => selectedUser(e)} onChange={formik.handleChange} appendTo="self" />
                </span>
                {getFormErrorMessage("user")}
              </div> 
            </div>
            <div>
              {selectedUsers && selectedUsers.length >= 1 && (
                <div>
                  {selectedUsers.map((item, i) => {
                    return (
                      <div key={i + "selectedUsers"}>
                        <div className="user-container">
                          <div className="grid">
                            <div className="col-8">
                              <span className="userName"> <b> {item[0].name}</b>{" "} </span>
                              <br />
                              <span className="userName"> <div> {item[0].designation} </div> </span>
                              <span className="userName">Availability :<b> {item[0].availability} %</b> </span>
                            </div>
                            <div className="col-4">
                              <div className="grid">
                                <div className="col-3 mt-2">
                                  <Checkbox id={item[0].id} name={item[0].name} checked={item[0].isBillable} onChange={handleBillable} />
                                </div>
                                <div className="col-3 mt-2">Billable</div>
                                <div className="col-2 mt-1">
                                  <Button icon="pi pi-times" type="button" className="p-button-rounded p-button-danger p-button-outlined userButton" onClick={(item) => deleteSelectedUser(item)} />
                                </div>
                              </div>
                            </div>
                          </div>
                          <Accordion activeIndex={null}>
                            <AccordionTab header="Resource Allocation">
                              <DataTable value={item[0].allocations} responsiveLayout="scroll">
                                <Column field="id" header="ID" style={{ minWidth: "5rem" }}></Column>
                                <Column field="project" header="Project" style={{ minWidth: "15rem" }}></Column>
                                <Column field="percentage" header="Allocation(%)" style={{ minWidth: "8rem" }}></Column>
                              </DataTable>
                            </AccordionTab>
                          </Accordion>
                        </div>
                      </div>
                    );
                  })}
                </div>
              )}
            </div>
          </div>
        )}
        <div className="grid mt-2">
          <label htmlFor="name" className={classNames({ "p-error": isFormFieldValid("name") })}></label>
          <div className="col-12">
            <div className="field-checkbox mb-0">
              <Checkbox className="mt-4" id="alloc100" name="alloc100" checked={formik.values.alloc100} onChange={allocHandler} disabled={fullAllocationDisabled} />
              <label className="checkbox-label allocationSelection" htmlFor="alloc100"> 100% Allocation </label>
            </div>
          </div>
          <div className="col-12">
            <div className="field-checkbox mb-0">
              <Checkbox className="mt-4" id="allocPart" name="allocPartial" checked={formik.values.allocPartial} onChange={allocHandler} disabled={partialAllocationDisabled} />
              <label className="checkbox-label allocationSelection" htmlFor="allocPart"> Partial Allocation </label>
            </div>
          </div>
          <div className="col-12">
            <div className="field-checkbox mb-0">
              <Checkbox className="mt-4" id="allocOt" name="ot" checked={formik.values.ot} onChange={allocHandler} disabled={otAllocationDisabled} />
              <label className="checkbox-label ml-3 allocationSelection" htmlFor="allocOt"> OT </label>
            </div>
          </div>
        </div>

        {formik.values.allocPartial && (
          <div className="partial-container">
            <div className="grid mt-3">
              <div className="col-4">
                <label htmlFor="other">Partial Allocation %</label>
              </div>
              <div className="col-8">
                <InputText id="allocOther" name="allocOther" style={{ width: "50px" }} value={formik.values.allocOther} onChange={(e) => {
                  if (e.target.value < 100) {
                    formik.handleChange(e);
                  }
                }}
                />
              </div>
              {getFormErrorMessage("allocOther")}
            </div>
          </div>
        )}
        <div className="" style={{ textAlign: "right", paddingTop: "25px" }}>
          <Button type="button" label="Cancel" className="p-button-rounded p-button-secondary"
            onClick={() => {
              setShow(false);
              formik.resetForm();
            }}
          />

          <Dialog style={{ textAlign: "center" }} header="Reason" visible={showRejDialog}
            onHide={() => {
              setShowRejDialog(false);
              clearReason();
            }}
          >
            <div>
              <InputTextarea style={{ width: "350px", height: "150px" }} id="reason" name="reason" value={formik.values.reason} onChange={(e) => formik.handleChange(e)}></InputTextarea>
            </div>
            <div style={{ marginTop: "20px", textAlign: "right" }}>
              <Button className="p-button-rounded p-button-secondary"
                onClick={() => {
                  setShowRejDialog(false);
                  clearReason();
                }}
              > Cancel </Button>
            </div>
          </Dialog>
          <Button type="submit" label="Allocate Now" className="p-button-rounded ml-2" onClick={() => setIsReject(false)} />
        </div>
      </form>
    </div>
  );
};
